"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var react_dom_1 = require("react-dom");

var Portal =
/** @class */
function (_super) {
  __extends(Portal, _super);

  function Portal(props) {
    var _this = _super.call(this, props) || this;

    _this.stopBodyScroll = function () {
      if (_this.bodyElem) _this.bodyElem.style.overflow = 'hidden';
    };

    var isServerSideRendering = _this.props.isServerSideRendering;

    if (isServerSideRendering()) {
      return _this;
    }

    _this.bodyElem = document.body;
    _this.modalContainer = document.createElement('div');
    return _this;
  }

  Portal.prototype.componentDidMount = function () {
    var isOpen = this.props.isOpen;

    if (isOpen) {
      this.open();
    }
  };

  Portal.prototype.componentDidUpdate = function (prevProps) {
    var isOpen = this.props.isOpen;

    if (!prevProps.isOpen && isOpen) {
      this.open();
    }

    if (prevProps.isOpen && !isOpen) {
      this.close();
    }

    if (isOpen) {
      this.stopBodyScroll();
    }
  };

  Portal.prototype.componentWillUnmount = function () {
    var isOpen = this.props.isOpen;

    if (isOpen) {
      this.close();
    }
  };

  Portal.prototype.close = function () {
    if (!this.bodyElem || !this.modalContainer) return;
    this.bodyElem.style.removeProperty('overflow');

    if (this.bodyElem.contains(this.modalContainer)) {
      this.bodyElem.removeChild(this.modalContainer);
    }
  };

  Portal.prototype.open = function () {
    if (!this.bodyElem || !this.modalContainer) return;
    this.stopBodyScroll();
    this.bodyElem.appendChild(this.modalContainer);
  };

  Portal.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        isOpen = _a.isOpen,
        isServerSideRendering = _a.isServerSideRendering;
    var shouldRenderPortal = isOpen && !isServerSideRendering();
    return shouldRenderPortal ? react_dom_1.createPortal(children, this.modalContainer) : null;
  };

  Portal.defaultProps = {
    isServerSideRendering: function () {
      return typeof window === 'undefined';
    }
  };
  return Portal;
}(react_1.Component);

exports.default = Portal;